import { useEffect, useState } from "react";

import { ActivityDeactivateBlockedDialog } from "./activity-deactivate-blocked-dialog";
import type { LinkedWorkOrderTemplateRef } from "../lib/activity-template-link-error";

type OpenPayload = {
  entityLabel: string;
  templates: LinkedWorkOrderTemplateRef[];
  mode?: "deactivate" | "delete";
};

let openHandler: ((payload: OpenPayload) => void) | null = null;
let resolveClose: (() => void) | null = null;

export function openActivityDeactivateBlockedDialog(
  payload: OpenPayload,
): Promise<void> {
  return new Promise((resolve) => {
    resolveClose = resolve;
    openHandler?.(payload);
  });
}

export function ActivityDeactivateBlockedDialogHost() {
  const [open, setOpen] = useState(false);
  const [entityLabel, setEntityLabel] = useState("");
  const [templates, setTemplates] = useState<LinkedWorkOrderTemplateRef[]>([]);
  const [mode, setMode] = useState<"deactivate" | "delete">("deactivate");

  useEffect(() => {
    openHandler = (payload) => {
      setEntityLabel(payload.entityLabel);
      setTemplates(payload.templates);
      setMode(payload.mode ?? "deactivate");
      setOpen(true);
    };
    return () => {
      openHandler = null;
    };
  }, []);

  const handleOpenChange = (next: boolean) => {
    setOpen(next);
    if (!next) {
      resolveClose?.();
      resolveClose = null;
    }
  };

  return (
    <ActivityDeactivateBlockedDialog
      open={open}
      onOpenChange={handleOpenChange}
      entityLabel={entityLabel}
      templates={templates}
      mode={mode}
    />
  );
}
